import { MarkupTheme } from '@/components/Markup/theme';
import { tw } from '@/utils/tw';

const Tiktok = tw.theme({
  extend: MarkupTheme,
});

export default Tiktok;
